"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Overlay = require("./Overlay.style");

var _excluded = ["children"];

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_Overlay.StyledOverlay, rest, children), document.body);
};

Overlay.defaultProps = {
  isGrey: false
};
Overlay.propTypes = {
  children: _propTypes["default"].node,
  isGrey: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = Overlay;
exports["default"] = _default;